import React from "react";
import { number, array, func, string, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";

import "./collectionNameTabs.m.css";

const CollectionNameTabs = ({ collectionList, selectedIndex = 0, onTabClick, className = "", publisherAttributes }) => {
  const headlineStyleName = `${publisherAttributes.lang}-headline`;
  return (
    <div styleName="base" className={className}>
      {collectionList.map((headline, index) => (
        <Headline
          key={index}
          text={headline}
          headlineType={16}
          headerLevel={3}
          onClick={() => onTabClick(index)}
          styleName={headlineStyleName}
          className={`${selectedIndex === index ? "active-tab" : ""} ${"tab-headline"} ${
            publisherAttributes.lang === "en" ? "en-tab-headline" : ""
          }`}
        />
      ))}
    </div>
  );
};

CollectionNameTabs.propTypes = {
  collectionList: array.isRequired,
  selectedIndex: number,
  onTabClick: func,
  className: string,
  publisherAttributes: object
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(CollectionNameTabs);
